import { _ as _toConsumableArray } from '../../../../toConsumableArray-2a2700d9.js';
import { i as isEqual_1 } from '../../../../isEqual-347ac7db.js';
import { SVG_ABSOLUTE_MARKERS, SVG_RELATIVE_MARKERS, MARKER_REG_EX } from '../../../../configs/index.js';
import '../../../../unsupportedIterableToArray-577176bf.js';
import '../../../../isObjectLike-66611f04.js';
import '../../../../typeof-92b42de1.js';
import '../../../../_commonjsHelpers-1789f0cf.js';

var L = SVG_ABSOLUTE_MARKERS.L,
    C = SVG_ABSOLUTE_MARKERS.C,
    Z = SVG_ABSOLUTE_MARKERS.Z;
var z = SVG_RELATIVE_MARKERS.z; // The curve control points

var moveTowardsFractional = function moveTowardsFractional(movingPoint, targetPoint, fraction) {
  return {
    x: movingPoint.x + (targetPoint.x - movingPoint.x) * fraction,
    y: movingPoint.y + (targetPoint.y - movingPoint.y) * fraction
  };
};

function adjustCommand(cmd, newPoint) {
  if (cmd.length > 2) {
    /* eslint-disable no-param-reassign */
    cmd[cmd.length - 2] = newPoint.x;
    cmd[cmd.length - 1] = newPoint.y;
    /* eslint-enable no-param-reassign */
  }
}

var pointForCommand = function pointForCommand(cmd) {
  return {
    x: parseFloat(cmd[cmd.length - 2]),
    y: parseFloat(cmd[cmd.length - 1])
  };
};

function roundPathCorners(pathString, radius) {
  var pathParts = pathString.split(' ').reduce(function (parts, part) {
    return [].concat(_toConsumableArray(parts), [part]);
  }, []).filter(function (existingChars) {
    return existingChars;
  }); // Group the commands and arguments

  var commands = pathParts.reduce(function (commandsAcc, part) {
    !part.match(MARKER_REG_EX) && commandsAcc.length ? commandsAcc[commandsAcc.length - 1].push(part) : commandsAcc.push([part]);
    return commandsAcc;
  }, []); // Group resulting commands

  var resultCommands = [];

  if (commands.length > 1) {
    var virtualCloseLine = null;
    var lastCommandIndex = commands.length - 1;
    var startPoint = pointForCommand(commands[0]);
    var isClosedWithZ = [Z, z].includes(commands[lastCommandIndex][0]);

    if (isClosedWithZ && commands[0].length > 2) {
      virtualCloseLine = [L, startPoint.x, startPoint.y];
      commands[lastCommandIndex] = virtualCloseLine;
    } // We always use the first command (but it may be mutated)


    resultCommands.push(commands[0]);

    for (var cmdIndex = 1; cmdIndex < commands.length; cmdIndex++) {
      var curCmd = commands[cmdIndex];
      var prevCmd = resultCommands[resultCommands.length - 1];
      var nextCmd = isEqual_1(curCmd, virtualCloseLine) ? commands[1] : commands[cmdIndex + 1]; // Nasty logic to decide if this path is a candidite.

      var hasCommands = nextCmd && prevCmd && prevCmd.length > 2 && nextCmd.length > 2;

      if (hasCommands && [curCmd[0], nextCmd[0]].includes(L)) {
        // Calc the points we're dealing with
        var prevPoint = pointForCommand(prevCmd);
        var curPoint = pointForCommand(curCmd);
        var nextPoint = pointForCommand(nextCmd); // The start and end of the curve are just our point moved towards the previous and next points, respectivly

        var curveStart = moveTowardsFractional(curPoint, prevCmd.origPoint || prevPoint, radius);
        var curveEnd = moveTowardsFractional(curPoint, nextCmd.origPoint || nextPoint, radius); // Adjust the current command and add it

        adjustCommand(curCmd, curveStart);
        curCmd.origPoint = curPoint;
        resultCommands.push(curCmd); // The curve control points are halfway between the start/end of the curve and the original point

        var startControl = moveTowardsFractional(curveStart, curPoint, 0.5);
        var endControl = moveTowardsFractional(curPoint, curveEnd, 0.5); // Curve and save the original point for fractional calculations

        var curveCmd = [C, startControl.x, startControl.y, endControl.x, endControl.y, curveEnd.x, curveEnd.y];
        curveCmd.origPoint = curPoint;
        resultCommands.push(curveCmd);
      } else {
        resultCommands.push(curCmd);
      }
    } // Fix up the starting point and restore the close path
    // if the path was orignally closed


    if (virtualCloseLine) {
      var newStartPoint = pointForCommand(resultCommands[resultCommands.length - 1]);
      resultCommands.push([Z]);
      adjustCommand(resultCommands[0], newStartPoint);
    }
  } else {
    resultCommands = commands;
  }

  return resultCommands.reduce(function (str, command) {
    return "".concat(str + command.join(' '), " ");
  }, '');
}

export { roundPathCorners as default };
